export default {
  services_number_title: "Number of services to choose from",
  additional_information_after_booking_title:
    "Additional information in the email after booking",
  additional_information_after_booking_subtitle:
    "Additional information that will be sent in emails related to service reservations (creation, modification, and reminders about the reservation). If you have edited the notifications, make sure the appropriate variable is set in their content: [ADDITIONAL_INFORMATION_AFTER_BOOKING].",
  additional_information_after_booking_dummy_text:
    "This is a sample text that will be replaced with additional information after booking, if such information has been provided in the service settings.",
  plugins_storage_100gb_cd_base_pro_name: "File storage 100 GB",
  plugins_storage_500gb_cd_base_pro_name: "File storage 500 GB",
  plugins_storage_100gb_cd_base_pro_description:
    "More file space. Gain 100 GB of additional space for file sharing with clients and receiving attachments via booking forms. An ideal solution to streamline communication and improve customer service.",
  plugins_storage_500gb_cd_base_pro_description:
    "Maximum space for your files. Use 500 GB of storage to exchange files with clients and receive attachments via booking forms without limitations. Essential for rapidly growing businesses that value professionalism and convenience.",
  bookings_this_month: "Bookings this month",
  bookings_all_processed: "All bookings",
  simple_store_product_transactions_this_month: "Products sold this month",
  files_storage_usage: "Used file storage",
  files_storage_usage_from_available_prefix: "of available",
  not_available_in_standard_plan: "Feature not available in the Standard plan",
  ai_tokens_usage: "AI tokens used",
  ai_tokens_usage_from_available_prefix: "of available",
  ai_tokens_resets_at: "Resets",
  cancel_reason_dropdown_label: "Reason for canceling your subscription",
  cancel_subscription_category_1_title: "Technical issues",
  cancel_subscription_category_1_reason_1_title: "Frequent crashes or downtime",
  cancel_subscription_category_1_reason_2_title: "Slow system performance",
  cancel_subscription_category_1_reason_3_title: "Hard-to-use interface",
  cancel_subscription_category_1_reason_4_title:
    "Problems with integrations (e.g., payment system, external calendars)",
  cancel_subscription_category_1_reason_5_title:
    "Security concerns (e.g., data breaches)",
  cancel_subscription_category_1_reason_6_title:
    "Problems with the employee’s mobile application (e.g., crashes, bugs)",
  cancel_subscription_category_2_title: "Personal or business changes",
  cancel_subscription_category_2_reason_1_title:
    "Business model change (e.g., reduced need for bookings)",
  cancel_subscription_category_2_reason_2_title:
    "Budget constraints or financial difficulties",
  cancel_subscription_category_2_reason_3_title:
    "Too much workload to manage the system",
  cancel_subscription_category_2_reason_4_title:
    "Closing or downsizing my business",
  cancel_subscription_category_2_reason_5_title:
    "Not enough time to manage bookings",
  cancel_subscription_category_3_title: "Pricing and competition",
  cancel_subscription_category_3_reason_1_title:
    "Cheaper alternatives available",
  cancel_subscription_category_3_reason_2_title:
    "Price increase or billing model change",
  cancel_subscription_category_4_title: "User experience issues",
  cancel_subscription_category_4_reason_1_title:
    "Difficult to navigate the system",
  cancel_subscription_category_4_reason_2_title: "Missing essential features",
  cancel_subscription_category_4_reason_3_title:
    "Too complex for my team or business",
  cancel_subscription_category_4_reason_4_title:
    "Slow or unhelpful customer support",
  cancel_subscription_category_4_reason_5_title:
    "Limited customization options",
  cancel_subscription_category_4_reason_6_title:
    "Complicated setup or onboarding process",
  cancel_subscription_category_5_title: "External and market factors",
  cancel_subscription_category_5_reason_1_title:
    "Market trends have shifted (e.g., moving to social media bookings)",
  cancel_subscription_category_5_reason_2_title:
    "Economic downturn or financial instability",
  cancel_subscription_category_5_reason_3_title: "Changes in legal regulations",
  cancel_subscription_category_6_title: "Other",
  cancel_subscription_category_6_reason_1_title: "A reason not listed here",
  cancel_subscription_category_6_reason_2_title: "I prefer not to say",
  cancel_plan_and_delete_data: "Cancel and delete my data",
  cancel_plan_do_nothing: "Do nothing",
  cancel_plan_and_keep_data_confirmation_label:
    "Are you sure you want to cancel your subscription but keep your data?",
  cancel_plan_and_keep_data_confirmation_info:
    "The subscription will be canceled at the end of the already paid billing period. The data will be securely stored on our servers and can be restored at any time upon reactivating the subscription.",
  scheduled_cancel_keeps_data_info:
    "Your plan will be canceled, but your data will remain stored",
  no_just_checking_title: "No, I’m just checking",
  payment_deadline_before_start_variable:
    "Payment deadline before the start of each recurring booking",
  send_payment_reminder_before_start_variable:
    "Time of payment reminder notification before the booking",
  booking_awaiting_payment_full_description:
    "Complete information about required payment",
  booking_awaiting_payment_full_description_example:
    "Your booking will be cancelled if no payment is made within 30 min. Click below to proceed to your booking and make the payment.",
  recurring_meeting_in_the_past_warning:
    'You cannot create a recurring meeting with start dates in the past. Choose a start date in the future or uncheck the "This event recurs" option.',
  // Booking overlaps dialog
  booking_overlaps_dialog_title: "Calendar conflict detected",
  booking_overlaps_dialog_message:
    "While verifying availability, we detected that the selected time conflicts with existing bookings or blackout dates. Conflict details:",
  booking_overlaps_count: "Number of conflicting bookings",
  unavailable_slot_overlaps_count: "Number of conflicting blackout dates",
  booking_overlaps_dialog_question: "Do you want to continue anyway?",
  selected_date: "Selected date",
  single_booking: "Single booking",
  external_api_service_not_enabled_error:
    "Unfortunately, the API feature is not available on this account.",
  service_not_available_at_selected_time:
    "The service is not available at the selected time.",
  offline_mode: "You are offline",
  offline_description:
    "The application requires an internet connection to function.",
  retry: "Retry",
  checking_connection: "Checking connection...",
  waiting_for_connection: "Waiting for connection",
  "2fa_verify_title": "Two-factor authentication",
  "2fa_verify_description":
    "Enter your 6-digit code from your authenticator app or use a recovery code:",
  "2fa_recovery_code_label": "Recovery code",
  "2fa_use_recovery_code": "Use recovery code instead",
  "2fa_use_app_code": "Use app code",
  "2fa_verify_incorrect_error": "The 2FA code is incorrect. Please try again.",
  "2fa_session_expired_error":
    "Your 2FA session has expired. Please log in again.",
  "2fa_verification_cancelled":
    "Two-factor authentication was cancelled. Please try again.",
  enable_2fa: "Enable 2FA",
  enable_2fa_title: "Turn on 2-step verification",
  disable_2fa: "Disable 2FA",
  disable_2fa_title: "Turn off 2-step verification",
  "2fa_manual_setup": "Can't scan? Enter this code manually:",
  "2fa_recovery_codes_title": "Recovery codes",
  "2fa_download_codes": "Download codes",
  "2fa_disable_description":
    "You're about to turn off 2-step verification. This will make your account less secure.",
  "2fa_disable_warning":
    "Disabling 2-step verification will reduce your account security.",
  "2fa_verify_to_disable": "Verify your identity",
  "2fa_verify_to_disable_description":
    "Enter a code from your authenticator app or use a recovery code to disable 2-step verification.",
  warning: "Warning",
  current_password: "Current password",
  incorrect_password: "Incorrect password. Please try again.",
  "2fa_setup_failed": "Failed to setup 2FA",
  "2fa_activation_failed": "Failed to activate 2FA",
  "2fa_verification_code": "Verification code",
  "2fa_disabled_success": "2FA has been successfully disabled",
  "2fa_disable_failed": "Failed to disable 2FA",
  "2fa_step_1_password_title": "Enter your password",
  "2fa_step_1_scan_title": "Scan QR code",
  "2fa_step_2_verify_title": "Verify setup",
  "2fa_authenticator_apps_required": "Authenticator app required",
  "2fa_setup_secure_subtitle":
    "Choose and install a secure 2FA app to protect your account",
  "2fa_apps_installation_note":
    "Install one of these apps on your phone before continuing with the setup.",
  "2fa_scan_with_app": "Scan this QR code with your authenticator app",
  "2fa_enter_code_from_app":
    "Enter the 6-digit code from your authenticator app",
  "2fa_recovery_codes_warning":
    "Store these codes in a secure location. Each code can only be used once.",
  "2fa_enter_password_to_continue":
    "Enter your current password to generate your unique QR code",
  "2fa_enter_password_to_disable":
    "Enter your current password to confirm disabling 2FA",
  "2fa_disable_verification_description":
    "Enter your current password and a code from your authenticator app or use a recovery code to disable 2-step verification.",
  "2fa_recovery_codes_description":
    "These backup codes allow you to access your account if you lose your authenticator app. Each code can only be used once, so keep them in a safe place.",
  security_settings: "Security settings",
  security_settings_description:
    "Manage your account security settings and authentication methods.",
  "2fa_security_title": "2-step verification",
  "2fa_security_description":
    "Add an extra layer of security to your account with 2-step verification.",
  reset_password_description:
    "Send a password reset link to your email address.",
  "2fa_enabled_success": "2FA has been successfully enabled",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input:
    "Link to a LinkedIn profile",
  logs_diff_linkedin: "Link to a LinkedIn profile",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input: "Link to a TikTok profile",
  logs_diff_tiktok: "Link to a TikTok profile",
  wb_linkedin: "LinkedIn URL",
  wb_tiktok: "TikTok URL",
  // Chatwoot package
  plugins_calendesk_chat_cd_base_standard_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_standard_description:
    "Enhance your customer communication with Calendesk Chat. Provide real-time support, answer questions, and engage with your clients directly from your booking page. Perfect for businesses that want to build stronger relationships with customers.",
  plugins_calendesk_chat_cd_base_pro_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_pro_description:
    "Enhance your customer communication with Calendesk Chat. Provide real-time support, answer questions, and engage with your clients directly from your booking page. Perfect for businesses that want to build stronger relationships with customers.",
  number_of_agents: "Number of agents",
  agents_plural: "agents",
  // Chatwoot integration
  integrations_category_customer_support: "Customer support",
  chatwoot_title: "Calendesk Chat",
  chatwoot_description:
    "Manage your live chat support. Access dashboard, configure agents, and view conversations.",
  chatwoot_package_not_active:
    "Calendesk Chat package is not active. Please activate it in your subscription settings.",
  chatwoot_setup_title: "Set up your chat support",
  chatwoot_setup_info:
    'Calendesk Chat is a separate application available at <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a> where you will manage conversations with customers.',
  chatwoot_setup_sso_warning:
    "All Calendesk administrators with access to integrations will be able to log in to the chat dashboard.",
  chatwoot_setup_next_steps_title: "After setup:",
  chatwoot_setup_next_step_1:
    'A chat account will be created at <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>',
  chatwoot_setup_next_step_2:
    "Administrators will be able to log in to the chat dashboard with one click from the Calendesk menu",
  chatwoot_setup_next_step_3:
    "You can add the chat widget to your booking page - the embed code is available in the chat dashboard",
  chatwoot_company_section_title: "Company details",
  chatwoot_admin_section_title: "Chat administrator",
  chatwoot_business_name: "Business name",
  chatwoot_business_name_hint:
    "Visible to customers in the chat widget and notifications",
  chatwoot_admin_name: "Name",
  chatwoot_admin_email: "Email",
  chatwoot_support_email: "Customer support email",
  chatwoot_support_email_placeholder: "e.g. support@yourcompany.com",
  chatwoot_support_email_hint:
    "Customers will see this address as the sender of email replies from your team",
  chatwoot_start_integration: "Set up",
  chatwoot_integration_active: "Calendesk Chat is active and ready to use.",
  chatwoot_dashboard_info:
    'Manage your conversations, agents, and settings in the chat dashboard at <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>.',
  chatwoot_sso_warning:
    "All Calendesk administrators with access to integrations can log in to the chat dashboard with one click.",
  chatwoot_open_dashboard: "Open dashboard",
  chatwoot_agent_limit: "Agent slots",
  chatwoot_buy_more_agents: "Need more agents? Upgrade your package",
  chatwoot_integration_success: "Calendesk Chat has been successfully set up!",
  chatwoot_integration_error:
    "Failed to set up Calendesk Chat. Please try again or contact support.",
  chatwoot_sso_error:
    "Failed to open chat dashboard. Please try again or contact support.",
  chatwoot_suspend_button: "Suspend",
  chatwoot_suspend_title: "Suspend Calendesk Chat",
  chatwoot_suspend_warning:
    "Suspending will deactivate the chat widget on the website for end customers, <strong>but does not affect the package activity or related charges</strong>.<br><br>To cancel the package, go to <strong>Billing → Subscription</strong> and select <strong>Disable</strong>.",
  chatwoot_suspend_confirm: "Suspend",
  chatwoot_suspend_success: "Calendesk Chat has been suspended.",
  chatwoot_suspend_error:
    "Failed to suspend Calendesk Chat. Please try again or contact support.",
  chatwoot_suspended_info:
    "Your Calendesk Chat account is currently suspended.",
  chatwoot_suspended_data_preserved:
    "All your conversations and settings are preserved and will be restored when you reactivate.",
  chatwoot_reactivate_button: "Reactivate",
  chatwoot_reactivation_success: "Calendesk Chat has been reactivated!",
  chatwoot_reactivation_error:
    "Failed to reactivate Calendesk Chat. Please try again or contact support.",
  chatwoot_suspended_tooltip: "Suspended - click to reactivate",
  chatwoot_agent_limit_exceeded:
    "You have @{current} agents, but your package allows only @{limit}.",
  chatwoot_agent_limit_contact_support:
    "To reactivate Calendesk Chat, please contact our support team. We will help you adjust the number of agents to match your package limit.",
  contact_support: "Contact support",
  chatwoot_min_agents_info:
    "Minimum @{count} agents required based on your current Calendesk Chat configuration.",
  chatwoot_close_confirm_title: "Close form?",
  chatwoot_close_confirm_warning:
    "Your entered data has not been saved and will be lost.",
  chatwoot_close_confirm_yes: "Close",
  chatwoot_close_confirm_no: "Back to form",

  dialog_close_confirm_title: "Close?",
  dialog_close_confirm_warning: "Unsaved changes will be lost.",
  dialog_close_confirm_yes: "Close",
  dialog_close_confirm_no: "Cancel",

  // Reports
  reports: "Reports",
  reports_granularity: "Group by",
  reports_revenue: "Revenue & Payments",
  reports_bookings: "Bookings",
  reports_team: "My team",
  reports_customers: "Customers & Commerce",
  reports_clients: "Clients",
  reports_subscriptions: "Subscriptions",
  reports_products: "Products",
  reports_tab_revenue: "Revenue",
  date_range: "Date range",
  vs_previous_period: "vs previous period",
  reports_revenue_timeline: "Revenue timeline",
  reports_top_services: "Top services",
  reports_top_products: "Top products",
  reports_payment_providers: "Payment methods",
  reports_payment_methods_count: "Transactions by payment method",
  reports_payment_methods_value: "Revenue by payment method",
  reports_payment_timeline: "Payment timeline",
  reports_bookings_timeline: "Bookings timeline",
  reports_by_service: "By service",
  reports_by_employee: "By employee",
  reports_by_delivery_type: "By delivery type",
  reports_cancellation_reasons: "Cancellation reasons",
  reports_by_day: "By day of week",
  reports_by_hour: "By hour",
  reports_heatmap: "Booking heatmap",
  reports_employee_performance: "Team performance",
  reports_service_ranking: "Service ranking",
  reports_by_category: "By category",
  reports_locations: "Locations",
  reports_customer_segments: "Client engagement",
  reports_top_customers: "Top clients",
  reports_product_revenue_timeline: "Product revenue timeline",
  reports_top_subscriptions: "Top subscriptions",
  reports_subscription_timeline: "New subscriptions over time",
  reports_revenue_forecast: "Revenue forecast",
  reports_bookings_forecast: "Bookings forecast",

  // Section headers
  reports_section_key_metrics: "Key metrics",
  reports_section_key_metrics_tooltip:
    "<b>Key metrics</b><br><br>Your main business indicators in the selected period. Arrows show changes compared to the previous period of the same length.",
  reports_section_trends: "Trends",
  reports_section_trends_tooltip:
    "<b>Trends</b><br><br>How your revenue and bookings changed over time in the selected period.",
  reports_section_revenue: "Revenue",
  reports_section_revenue_tooltip:
    "<b>Revenue</b><br><br>Total income from all sources in the selected period. Only <b>completed payments</b> are counted.<br><br>Includes:<br>• <b>Revenue breakdown</b> — from bookings, subscriptions, and products<br>• <b>Avg booking value</b> and <b>booking payment rate</b><br>• <b>Revenue timeline</b> — how income changed over time<br>• <b>Top services, subscriptions, and products</b> — ranked by revenue<br>• <b>Payment methods</b> — transaction count and revenue per method",
  reports_section_bookings: "Bookings",
  reports_section_bookings_tooltip:
    "<b>Bookings</b><br><br>Booking statuses, volume over time, and breakdown by service and team member in the selected period.<br><br>Includes:<br>• <b>Status breakdown</b> — approved, done, cancelled counts<br>• <b>Bookings timeline</b> — volume changes over time<br>• <b>By service and team member</b> — most booked services and busiest staff",
  reports_section_patterns: "Booking patterns",
  reports_section_patterns_tooltip:
    "<b>Booking patterns</b><br><br>When your clients prefer to book. Use this to optimize your schedule.<br><br>Includes:<br>• <b>Peak hours heatmap</b> — busiest days and hours<br>• <b>Busiest day</b> — which day of the week gets the most bookings<br>• <b>By hour</b> — booking distribution across the day",
  reports_section_employees: "My team",
  reports_section_employees_tooltip:
    "<b>My team</b><br><br>How each team member performed in the selected period.<br><br>Includes:<br>• <b>Bookings completed</b> — number of done bookings per person<br>• <b>Revenue generated</b> — income from their bookings<br>• <b>Schedule fill rate</b> — how much of their available time was booked",
  reports_section_services: "Services",
  reports_section_services_tooltip:
    "<b>Services</b><br><br>Most popular services and their revenue in the selected period.<br><br>Includes:<br>• <b>Bookings per service</b> — number of approved and done bookings<br>• <b>Revenue per service</b> — income generated",
  reports_section_locations: "Locations",
  reports_section_locations_tooltip:
    "<b>Locations</b><br><br>Performance breakdown by business location and delivery type in the selected period.",
  reports_section_customers: "Customers",
  reports_section_customers_tooltip:
    "<b>Customers</b><br><br>Who books most often, who spends the most, and how engaged your clients are in the selected period.<br><br>Includes:<br>• <b>New clients</b> — registered in the selected period<br>• <b>Active clients</b> — had at least one booking<br>• <b>Engagement chart</b> — first-timers vs returning vs loyal regulars<br>• <b>Top customers</b> — highest spenders in the selected period",
  reports_section_customer_overview: "Clients",
  reports_section_customer_overview_tooltip:
    "<b>Clients</b><br><br>These values cover your entire history and don't change with the date filter.",
  reports_section_customer_activity: "Activity in period",
  reports_section_customer_activity_tooltip:
    "<b>Activity in period</b><br><br>How your clients engaged in the selected period — bookings, retention, and preferences.",
  reports_section_products: "Products",
  reports_section_products_tooltip:
    "<b>Products</b><br><br>Product sales, revenue over time, and best sellers in the selected period.<br><br>Includes:<br>• <b>Total product revenue</b> in the selected period<br>• <b>Revenue timeline</b> — how product sales changed over time<br>• <b>Top products</b> — best sellers ranked by revenue",
  reports_section_subscriptions: "Subscriptions",
  reports_section_subscriptions_tooltip:
    "<b>Subscriptions</b><br><br>Revenue, renewals, and usage of your subscription plans in the selected period.<br><br>Includes:<br>• <b>Active subscriptions</b> — how many clients have an active plan right now<br>• <b>Revenue</b> — how much you earned from subscriptions in the selected period<br>• <b>Renewal rate</b> — how many subscribers paid more than once (higher = clients keep coming back)<br>• <b>Top subscriptions</b> — which plans bring in the most money<br>• <b>Usage</b> — are subscribers actually using their included bookings?",
  reports_section_booking_status: "Booking status",
  reports_section_cancellation_reasons: "Cancellation reasons",
  reports_section_peak_hours: "Peak hours",
  reports_section_peak_hours_tooltip:
    "<b>How to read this chart:</b><br><br><b>Rows</b> = days of the week<br><b>Columns</b> = hours of the day (00:00–23:00)<br><br>Each cell shows the <b>total number</b> of approved and done bookings scheduled at that day and hour across the <b>entire selected period</b>.<br><br><b>Example:</b> If you selected 3 months, the cell at Monday 10:00 shows how many bookings fell on any Monday at 10:00 during those 3 months combined.<br><br>🟦 Darker color = more bookings",
  reports_section_busiest_day: "Busiest day of week",
  stats_monday: "Monday",
  stats_tuesday: "Tuesday",
  stats_wednesday: "Wednesday",
  stats_thursday: "Thursday",
  stats_friday: "Friday",
  stats_saturday: "Saturday",
  stats_sunday: "Sunday",
  stats_mon: "Mon",
  stats_tue: "Tue",
  stats_wed: "Wed",
  stats_thu: "Thu",
  stats_fri: "Fri",
  stats_sat: "Sat",
  stats_sun: "Sun",
  reports_section_delivery_type: "By delivery type",
  reports_section_peak_times: "Peak times",
  reports_bookings_by_hour: "Bookings by hour",
  reports_bookings_by_service: "Top services",
  reports_bookings_by_employee: "Top team members",
  reports_booking_lead_time: "Booking lead time",
  reports_bookings_by_location: "Bookings by location",

  // Renderer-specific notes
  reports_employee_performance_note:
    'Schedule fill rate shows "--" if no working hours are set for this team member.',
  reports_customer_segments_note:
    "Breaks down active clients into three groups based on booking history. All three sum to active clients.",
  reports_top_customers_note:
    "Total spent shown is across all time, not just the selected period.",
  reports_bookings_timeline_note:
    "Approved and done bookings, based on the booking date.<br><br><b>Forecast</b>: a dashed line shows upcoming periods — bookings that are already scheduled (approved or awaiting payment).",
  reports_services_by_category: "Bookings by category",
  reports_services_by_category_note:
    "Number of approved and done bookings per service category in the selected period.",
  reports_service_ranking_note:
    "Sorted by number of bookings. Click any column to re-sort.",
  reports_top_products_note:
    "Products ranked by revenue in the selected period.",
  reports_top_subscriptions_note:
    "Subscription plans ranked by revenue in the selected period.",
  reports_product_revenue_timeline_note:
    "How product revenue changed over time in the selected period.",
  reports_subscription_timeline_note:
    "Number of new subscriptions started per period.",
  reports_mrr_trend: "New subscriptions",
  reports_subscription_usage: "Subscription usage",
  reports_subscription_usage_tooltip:
    "Are your subscribers actually using the bookings included in their plans?<br><br>• <b>Booking limit usage</b> — if a plan includes 10 bookings and a client used 3, that's 30%. This is the average across all subscribers.<br>• <b>Unused bookings</b> — the total number of included bookings that nobody used. A high number means subscribers are leaving value on the table.",

  // Stats labels — KPI cards, table columns, chart headers
  // Dashboard
  stats_revenue: "Revenue",
  stats_bookings: "Bookings",
  stats_subscriptions: "Subscriptions",
  stats_products: "Products",
  stats_new_customers: "New customers",
  stats_cancellation_rate: "Cancellation rate",
  // Revenue
  stats_avg_booking_value: "Avg booking value",
  stats_total_revenue: "Total revenue",
  stats_from_bookings: "Bookings",
  stats_from_products: "Products",
  stats_from_subscriptions: "Subscriptions",
  // Team
  stats_active_employees: "Active employees",
  stats_team_revenue: "Team revenue",
  stats_schedule_fill_rate: "Schedule fill rate",
  stats_total_booked_hours: "Total booked hours",
  // Bookings
  stats_total_bookings: "Total bookings",
  stats_approved: "Approved",
  stats_done: "Done",
  stats_cancelled: "Cancelled",
  stats_payment: "Awaiting payment",
  stats_status: "Status",
  // Tables — common
  stats_service: "Service",
  stats_employee: "Employee",
  stats_delivery_type: "Delivery type",
  stats_share: "Share",
  stats_reason: "Reason",
  stats_cancellations: "Cancellations",
  stats_category: "Category",
  stats_location: "Location",
  stats_type: "Type",
  stats_provider: "Method",
  stats_transactions: "Transactions",
  stats_value: "Total",
  stats_product: "Product",
  stats_quantity: "Quantity",
  stats_subscription: "Subscription",
  stats_customer: "Customer",
  stats_email: "Email",
  // Employees
  stats_customers_served: "Customers served",
  stats_utilization: "Utilization",
  stats_available_hours: "Available hours",
  stats_booked_hours: "Booked hours",
  // Services
  stats_unique_customers: "Unique customers",
  // Customers
  stats_total_customers: "Total customers",
  stats_active_customers: "Active customers",
  stats_returning_customers: "Returning customers",
  stats_retention_rate: "Retention rate",
  stats_customer_ltv: "Lifetime value",
  stats_avg_days_between_visits: "Avg days between bookings",
  stats_preferred_delivery: "Preferred delivery",
  stats_preferred_payment: "Preferred payment",
  stats_total_spent: "Total spent",
  // Products
  stats_total_sold: "Total sold",
  stats_product_revenue: "Product revenue",
  // Subscriptions
  stats_active_subscriptions: "Active subscriptions",
  stats_subscription_revenue: "Subscription revenue",
  stats_renewal_rate: "Renewal rate",
  stats_active_users: "Active users",
  stats_avg_utilization: "Booking limit usage",
  stats_booking_limit_usage: "Booking limit usage",
  stats_unused_booking_slots: "Unused bookings",
  stats_unused_bookings: "Unused bookings",
  // Payments
  stats_total_transactions: "Total transactions",
  stats_total_value: "Total value",
  stats_booking_payment_rate: "Booking payment rate",
  stats_method: "Method",
  // Patterns
  stats_day: "Day",
  stats_hour: "Hour",
  stats_busiest_day: "Busiest day",
  stats_busiest_hour: "Busiest hour",
  stats_average_lead_time: "Avg. days in advance",
  stats_median_lead_time: "Median days in advance",
  // Forecast
  stats_month: "Month",
  stats_projected: "Projected",
  stats_low_estimate: "Low estimate",
  stats_high_estimate: "High estimate",
  // Chart field names
  stats_period: "Period",
  stats_count: "Count",
  stats_name: "Name",

  // KPI tooltips
  stats_cancellation_rate_tooltip:
    "How often bookings get cancelled.<br><br><b>Formula:</b> cancelled ÷ (approved + done + cancelled)<br><b>Example:</b> 10 bookings, 2 cancelled = <b>20%</b>",
  stats_customer_ltv_tooltip:
    "How much a client has spent with you in total, across their entire history — not just the selected period.",
  stats_utilization_tooltip:
    "How full your schedule is.<br><br><b>100%</b> — every available slot was booked<br><b>50%</b> — half your working time had no bookings",
  stats_booking_payment_rate_tooltip:
    "Percentage of bookings that were paid, out of all bookings scheduled in the selected period.",
  stats_renewal_rate_tooltip:
    "How many subscribers continued their plan after the first payment — a sign of client satisfaction.",
  stats_unused_booking_slots_tooltip:
    "The total number of bookings that subscribers could have made (based on their plan limits) but didn't.<br><br><b>Example:</b> 3 subscribers each have a plan with 10 bookings/month. One used 7, one used 3, one used 0. That's 3 + 7 + 10 = <b>20 unused bookings</b>.<br><br>A high number might mean your limits are too generous or subscribers need a reminder to book.",
  stats_active_subscriptions_tooltip:
    "New subscription plans that started in the selected period. This is <b>not</b> the total number of all active subscribers.",
  stats_avg_utilization_tooltip:
    "Some subscription plans include a set number of bookings (e.g. \"10 bookings per month\"). This shows what percentage of those included bookings your subscribers actually used.<br><br><b>Example:</b> A client buys a plan with 10 bookings/month but only books 3 times → that's 30% usage.<br><br>A low percentage means subscribers aren't fully using what they paid for. Only counts approved and done bookings.",
  // Dashboard KPIs
  stats_new_customers_tooltip:
    "New clients who registered in the selected period. Based on account creation date.",
  // Revenue section KPIs
  stats_total_revenue_tooltip:
    "Total income in the selected period from:<br>• bookings<br>• subscriptions<br>• product sales<br><br>Only <b>completed payments</b> are counted, based on the payment date.",
  stats_from_bookings_tooltip:
    "Revenue from booking payments in the selected period. Only <b>completed payments</b> are counted.",
  stats_from_products_tooltip:
    "Revenue from one-time product purchases in the selected period.",
  stats_from_subscriptions_tooltip:
    "Revenue from subscription plan payments in the selected period.",
  // Booking status KPIs
  stats_total_bookings_tooltip:
    "Total <b>approved</b> and <b>done</b> bookings in the selected period. <b>Cancelled</b> and <b>awaiting payment</b> bookings are not counted.",
  stats_approved_tooltip:
    "Bookings that are <b>approved</b> (confirmed) but haven't taken place yet.",
  stats_done_tooltip:
    "Bookings that were successfully completed (<b>done</b>) in the selected period.",
  stats_cancelled_tooltip:
    "Bookings that were <b>cancelled</b> in the selected period — by either the client or you.",
  // Team summary KPIs
  stats_active_employees_tooltip:
    "Team members who had at least one approved or done booking in the selected period.",
  stats_team_revenue_tooltip:
    "Total booking revenue across all team members in the selected period. Only completed payments are counted.",
  stats_schedule_fill_rate_tooltip:
    'How much of your team\'s available time is filled with bookings.<br><br><b>How it works:</b><br>1. For each team member, we count every day in the selected period<br>2. For each day, we check their schedule — specific date overrides (days off, special hours) take priority over the regular weekly schedule<br>3. We add up all their booked hours (approved and done bookings)<br>4. Fill rate = booked hours ÷ available hours<br>5. We average this across all team members<br><br><b>Example:</b> Anna has 40h available, 20h booked → 50%. Mark has 40h available, 30h booked → 75%. Average = <b>62.5%</b><br><br>Team members without a schedule are skipped. Shows "--" if no one has a schedule set.',
  stats_total_booked_hours_tooltip:
    "Total hours spent on bookings across all team members in the selected period.",
  // Employee KPIs
  stats_customers_served_tooltip:
    "Number of different clients this team member worked with in the selected period.",
  stats_available_hours_tooltip:
    'How many hours this team member could work in the selected period, based on their schedule.<br><br><b>How it works:</b> We check every day in the selected period. For each day, we look at the schedule — if there\'s a specific date override (e.g. a day off), we use that. Otherwise, we use the regular weekly schedule for that weekday.<br><br><b>Example:</b> Mon–Fri 9:00–17:00. Period = Mon to Sun → 5 working days × 8h = <b>40h</b>. If Wednesday is marked as a day off, it becomes 4 × 8h = <b>32h</b>.<br><br>Shows "--" if no schedule is set.',
  stats_booked_hours_tooltip:
    "Working hours that were actually filled with bookings in the selected period.",
  // Customer KPIs
  stats_total_tooltip:
    "Total number of clients registered with you — across all time, not just the selected period.",
  stats_new_tooltip:
    "Clients who booked for the first time in the selected period — they had no bookings before.",
  stats_active_tooltip:
    "Clients who had at least one <b>approved</b> or <b>done</b> booking in the selected period.",
  stats_returning_tooltip:
    "Clients who had a booking before the selected period and came back again during it.",
  stats_ltv_tooltip:
    "Average total amount spent by a client since they first joined — across their entire history, not just the selected period.",
  stats_preferred_delivery_type_tooltip:
    "The most common booking format your clients choose — for example, in person, via phone, or online.",
  stats_preferred_payment_method_tooltip:
    "The payment method your clients use most often when paying for bookings.",
  stats_total_customers_tooltip:
    "Total number of registered clients — across all time, not just the selected period.",
  stats_active_customers_tooltip:
    "Clients who had at least one booking in the selected period.",
  stats_returning_customers_tooltip:
    "Clients who had bookings before the selected period and came back during it. With <b>All time</b> selected, this will be 0.",
  stats_retention_rate_tooltip:
    "What percentage of active clients had booked with you before.<br><br><b>Formula:</b> returning ÷ active × 100<br><b>Example:</b> 10 active, 6 returning = <b>60%</b>",
  stats_avg_days_between_visits_tooltip:
    "On average, how many days pass between bookings for clients who come back more than once.",
  // Product KPIs
  stats_total_sold_tooltip: "Number of products sold in the selected period.",
  stats_product_revenue_tooltip:
    "Total revenue from product sales in the selected period.",
  // Subscription KPIs
  stats_subscription_revenue_tooltip:
    "Total revenue from subscription plan payments in the selected period.",
  stats_active_users_tooltip:
    "Subscribers who made at least one booking using their subscription plan in the selected period.",
  // Payment KPIs
  stats_total_value_tooltip:
    "Sum of all <b>completed</b> payment transactions (bookings, products, and subscriptions) in the selected period.",
  // Pattern KPIs
  stats_busiest_day_tooltip:
    "The day of the week with the most bookings in the selected period.",
  stats_busiest_hour_tooltip:
    "The hour of the day with the most bookings in the selected period.",
  stats_peak_times_tooltip:
    "The day and hour with the most <b>approved</b> and <b>done</b> bookings in the selected period.",
  stats_bookings_by_hour_tooltip:
    "How bookings are distributed across hours of the day in the selected period.",
  stats_bookings_by_service_tooltip:
    "Which services received the most bookings in the selected period.",
  stats_bookings_by_employee_tooltip:
    "Which team members handled the most bookings in the selected period.",
  stats_booking_lead_time_tooltip:
    "How far in advance clients typically book — the number of days between booking creation and the booking date.",
  stats_bookings_by_location_tooltip:
    "How bookings are distributed across your business locations in the selected period.",
  stats_average_lead_time_tooltip:
    "The average number of days between when a booking is created and when it takes place.",
  stats_median_lead_time_tooltip:
    "The median number of days between when a booking is created and when it takes place. Less affected by outliers than the average.",
  // Forecast KPIs
  stats_low_estimate_tooltip:
    "The lower end of the forecast — your results might be around this level if the next period is slower than usual.",
  stats_high_estimate_tooltip:
    "The upper end of the forecast — the optimistic scenario for the next period.",
  // Widget-specific tooltips (shared with dashboard widgets)
  stats_booking_status_tooltip:
    "Breakdown of your bookings by status — <b>approved</b>, <b>done</b>, and <b>cancelled</b> — in the selected period.",
  stats_avg_booking_value_tooltip:
    "The average amount paid per booking in the selected period.<br><br><b>Formula:</b> booking revenue ÷ number of paid bookings",
  stats_mrr_tooltip:
    "Total revenue from subscription plan payments in the selected period. Shows the sum of all paid subscription transactions, not a normalized monthly rate.",
  stats_top_clients_tooltip:
    "Your highest-spending clients in the selected period, ranked by total revenue.",
  stats_top_service_tooltip:
    "The service with the most bookings in the selected period.",
  stats_revenue_trend_tooltip:
    "How your revenue changed in the selected period. Includes bookings, subscriptions, and product sales.<br><br><b>Forecast:</b> dashed line shows upcoming periods — booking revenue already collected or awaiting payment, plus estimated monthly income from active subscriptions.",
  stats_bookings_timeline_tooltip:
    "How the number of bookings changed in the selected period. Includes <b>approved</b> and <b>done</b> bookings.<br><br><b>Forecast:</b> dashed line shows upcoming periods — bookings that are already scheduled (<b>approved</b> or <b>awaiting payment</b>).",
  stats_peak_hours_heatmap_tooltip:
    "Heatmap showing when most bookings happen — by day of the week and hour of the day. Darker cells = more bookings.",
  stats_booking_revenue_tooltip:
    "Revenue from booking payments only in the selected period — excludes product sales and subscriptions.",
  stats_total_transactions_tooltip:
    "Total number of payment transactions processed in the selected period, across all payment sources.",
  stats_payment_timeline_tooltip:
    "How the total value of payments changed over time in the selected period.",
  stats_revenue_timeline_tooltip:
    "Revenue broken down by source — bookings, subscriptions, and products. Only completed payments, based on the payment date. Click legend items to show or hide lines.<br><br><b>Forecast</b>: dashed lines show projected revenue — from bookings already paid or awaiting payment, plus estimated income from active subscriptions.",
  stats_revenue_top_services_table_tooltip:
    "Services ranked by revenue in the selected period.",
  stats_revenue_top_products_table_tooltip:
    "Products ranked by revenue in the selected period.",
  stats_payment_providers_chart_tooltip:
    "Number of <b>completed</b> transactions by payment method (e.g. Stripe, cash, card) in the selected period.",
  stats_payment_methods_count_chart_tooltip:
    "How many transactions were processed through each payment method in the selected period.",
  stats_payment_methods_value_chart_tooltip:
    "Total revenue collected through each payment method in the selected period.",
  stats_booking_status_chart_tooltip:
    "Bookings by status — <b>approved</b>, <b>done</b>, <b>cancelled</b>, and <b>awaiting payment</b> — in the selected period.",
  stats_cancellation_reasons_chart_tooltip:
    "Most common reasons clients cancelled their bookings in the selected period.",
  stats_busiest_day_chart_tooltip:
    "Which days of the week have the most bookings in the selected period.",
  stats_delivery_type_chart_tooltip:
    "How bookings are split across delivery types — in-person, online, phone, etc. — in the selected period.",
  stats_customer_segments_chart_tooltip:
    "How engaged your active clients are in the selected period:<br>• <b>First-time</b> — first booking ever, no prior history<br>• <b>Came back</b> — had bookings before, visited once in this period<br>• <b>Loyal</b> — had bookings before and came 2+ times in this period",
  stats_top_customers_table_tooltip:
    "Your highest-spending clients in the selected period — full table with export option.",
  stats_employee_table_tooltip:
    "Performance overview for each team member — bookings, hours, and utilization in the selected period.",
  stats_service_table_tooltip:
    "Performance overview for each service — bookings and revenue in the selected period.",
  stats_services_by_category_tooltip:
    "Number of approved and done bookings per service category in the selected period.",
  stats_subscription_timeline_tooltip:
    "How many new subscriptions were purchased per period. Counts subscription start dates — renewals are not included.",
  stats_top_subscriptions_table_tooltip:
    "Subscription plans ranked by number of active subscribers in the selected period.",
  stats_product_timeline_tooltip:
    "How product revenue changed in the selected period.",
  stats_top_products_table_tooltip:
    "Products ranked by sales volume and revenue in the selected period.",
  stats_not_assigned: "Not assigned",
  stats_low: "Low",
  stats_medium: "Medium",
  stats_high: "High",
  stats_insufficient: "Insufficient data",
  stats_type_name: "Delivery type",
  stats_new_subscriptions: "New subscriptions",
  stats_new: "New",
  stats_returning: "Returning",
  stats_first_time: "First-time",
  stats_first_time_tooltip:
    "Clients with no bookings before the selected period — this is their first visit.",
  stats_came_back: "Came back",
  stats_came_back_tooltip:
    "Clients who had bookings before the selected period and booked once in this period.",
  stats_loyal: "Loyal",
  stats_loyal_tooltip:
    "Clients who had bookings before the selected period and booked 2+ times in this period.",
  stats_staff: "Staff",
  stats_payment_timeout: "Payment timeout",
  stats_calendar_sync: "Calendar sync",
  stats_in_person: "Address",
  stats_phone: "Phone",
  stats_other: "Other",
  stats_stripe: "Stripe",
  stats_cash: "Cash",
  stats_card: "Card",
  stats_transfer: "Transfer",
  stats_google_meet: "Google Meet",
  stats_zoom: "Zoom",
  stats_microsoft_teams: "Microsoft Teams",
  stats_skype: "Skype",
  stats_whatsapp: "WhatsApp",
  stats_client: "Customer",
  stats_no_payment: "Payment timeout",
  stats_external: "Calendar sync",
  bulk_operation_progress: "Processing: @{done} of @{total}",
  bulk_operation_counting: "Counting records...",
  bulk_action_delete_bookings: "Deleting bookings",
  bulk_action_delete_users: "Deleting users",
  bulk_action_update_users: "Updating users",
  bulk_action_export_users: "Exporting users",
  bulk_action_add_to_group: "Adding to groups",
  bulk_action_remove_from_group: "Removing from groups",
  bulk_action_send_notification: "Sending notifications",
  bulk_action_update_bookings: "Updating bookings",
  bulk_action_export_events: "Exporting events",
  bulk_action_update_employees: "Updating employees",
  bulk_action_delete_employees: "Deleting employees",
  bulk_action_export_employees: "Exporting employees",
  bulk_notification_sending: "Sending notifications...",
  bulk_export_generating: "Generating file...",
  bulk_export_sent_to_email: "File sent to your email",
  bulk_export_sent_to_email_with_errors:
    "File sent to your email. Processed: @{processed}, failed: @{failed}.",
  download_csv: "Download CSV",
  selection_all_on_page: "All @{amount} records on this page are selected.",
  selection_select_all_records: "Select all @{total} records across all pages",
  selection_all_records_selected:
    "All @{total} records across all pages are selected.",

  // Dashboard widgets
  your_overview: "Your overview",
  add_widget: "Add widget",
  widget_group_revenue: "Revenue",
  widget_group_bookings: "Bookings",
  widget_group_clients: "Clients",
  widget_group_team: "My team",
  widget_group_subscriptions: "Subscriptions",
  widget_group_products: "Products",
  widget_revenue_kpi: "Revenue",
  widget_bookings_kpi: "Bookings",
  widget_new_clients_kpi: "New clients",
  widget_revenue_trend: "Revenue trend",
  widget_cancellation_rate: "Cancellation rate",
  widget_top_clients: "Top clients",
  widget_peak_hours_heatmap: "Peak hours",
  widget_avg_booking_value: "Avg booking value",
  widget_payment_method: "Preferred payment method",
  widget_bookings_timeline: "Bookings timeline",
  widget_booking_status: "Booking status",
  widget_busiest_day: "Busiest day",
  widget_busiest_hour: "Busiest hour",
  widget_avg_lead_time: "Avg lead time",
  widget_active_clients: "Active clients",
  widget_retention_rate: "Retention rate",
  widget_employee_utilization: "Employee utilization",
  widget_top_service: "Top service",
  widget_active_subscriptions: "Active subscriptions",
  widget_mrr: "Subscription revenue",
  widget_product_revenue: "Product revenue",
  widget_booking_revenue: "Booking revenue",
  widget_total_transactions: "Total transactions",
  widget_payment_conversion: "Booking payment rate",
  widget_payment_timeline: "Payment timeline",
  widget_revenue_timeline: "Revenue timeline",
  widget_revenue_top_services_table: "Top services by revenue",
  widget_revenue_top_products_table: "Top products by revenue",
  widget_payment_providers_chart: "Payment methods",
  widget_booking_status_chart: "Booking status breakdown",
  widget_cancellation_reasons_chart: "Cancellation reasons",
  widget_busiest_day_chart: "Bookings by day of week",
  widget_delivery_type_chart: "Delivery type breakdown",
  widget_customer_segments_chart: "Client segments",
  widget_top_customers_table: "Top clients (full table)",
  widget_employee_table: "Employee performance",
  widget_service_table: "Service performance",
  widget_subscription_timeline: "New subscriptions over time",
  widget_top_subscriptions_table: "Top subscription plans",
  widget_product_timeline: "Product revenue timeline",
  widget_top_products_table: "Top products",
  widget_bookings_by_service_table: "Bookings by service",
  widget_bookings_by_employee_table: "Top team members",
  widget_bookings_by_hour_chart: "Bookings by hour",
  widget_locations_table: "Bookings by location",
  widget_total_clients: "Total clients",
  widget_customer_ltv: "Client lifetime value",
  widget_returning_clients: "Returning clients",
  widget_avg_days_between_visits: "Avg days between visits",
  widget_first_time_clients: "First-time clients",
  widget_repeat_clients: "Repeat clients",
  widget_loyal_clients: "Loyal clients",
  widget_services_by_category_chart: "Bookings by category",
  widget_renewal_rate: "Renewal rate",
  widget_subscription_utilization: "Subscription utilization",
  widget_unused_booking_slots: "Unused booking slots",
  widget_total_products_sold: "Total products sold",
  restore_defaults: "Restore defaults",
  restore_defaults_warning:
    "This will reset your dashboard to the default widgets. Your current layout will be lost.",
  drag_to_reorder: "Drag to reorder",
  tooltip_add_widget: "Add a new widget to your dashboard",
  tooltip_edit_layout: "Rearrange or remove widgets",
  tooltip_restore_defaults: "Reset to the default widget layout",
  tooltip_save_layout: "Save your current widget layout",
  tooltip_remove_widget: "Remove this widget",
  add_more_widgets: "Add more widgets",
  all_time: "All time",
  remove_from_group: "Remove from group",
  change_status_to_approved: "Set as approved",
  change_status_to_payment: "Set as awaiting payment",
  change_status_to_cancelled: "Set as cancelled",
  change_status_to_done: "Set as done",
  bulk_operation_already_active:
    "You already have an active bulk operation. Please wait for it to complete.",
};
